<template>
  <div class="maintenance-page-wrapper">
    <Breadcrumbs main="" title="Maintenance Window" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
            <div class="maintenance-page-header">
              <!-- Search Bar Row -->
              <b-row class="mb-3">
                <b-col md="4">
                  <div class="maintenance-page-search-wrapper">
                    <b-input-group>
                      <b-input-group-prepend>
                        <span class="input-group-text search-icon">
                          <i class="icofont icofont-search-alt-2"></i>
                        </span>
                      </b-input-group-prepend>
                      <b-form-input
                        class="maintenance-page-search-input"
                        v-model="filter"
                        placeholder="Search"
                        type="search"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col md="8" class="d-flex justify-content-end align-items-center">
                  <div class="maintenance-page-per-page-wrapper">
                    <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span>Per page : </span>
                    <div class="select-wrapper">
                      <b-form-select
                        class="maintenance-page-per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="getMantenance"
                      >
                      </b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                  <button class="maintenance-page-add-btn ml-3" @click="add_maint_modal = true">
                    <img src="@/assets/icons/add-mwindow.svg" alt="Add Maintenance" class="add-maintenance-icon" />
                    Add New Maintenance
                  </button>
                  <add-monitor-button 
                    class="ml-3" 
                    :icon-only="true" 
                    variant="green"
                  />
                </b-col>
              </b-row>
            </div>
              <div class="col-md-12" v-if="loading">
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <div v-else class="maintenance-page-table-container">
                <b-table
                  class="maintenance-page-table"
                  show-empty
                  stacked="md"
                  :items="items"
                  :filter="filter"
                  :fields="tablefields"
                  :per-page="perPage"
                  @filtered="onFiltered"
                  borderless
                >
                <template #cell(index)="data">
                  <span class="maintenance-sr-number">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
                </template>
                <template #cell(name)="data">
                  <span>{{ data.item.name }}</span>
                </template>
                <template #cell(duration)="data">
                  <span>{{ data.item.duration }} min.</span>
                </template>
                <template #cell(startTime)="data">
                  <!-- <span v-if="data.item.type == 1"> 
                    - -->
                    <!-- <span v-for="l in data.item.value" :key="l">
                      {{ new Date(l).toLocaleTimeString([], { hour: "2-digit",minute: "2-digit",hour12: true }) }}
                    </span> -->
                  <!-- </span> -->
                  <span>
                    {{ data.item.startTime }}
                      <!-- {{ new Date(data.item.startTime).toLocaleTimeString([], { hour: "2-digit",minute: "2-digit",hour12: false }) }} -->
                  </span>
                </template>
                <template #cell(type)="data">
                  <span>{{ maintenance_opt[data.item.type].text }}</span>
                </template>
                <template #cell(status)="data">
                    <div class="status-toggle">
                        <label class="switch">
                        <input type="checkbox" :checked=data.item.status @change="statusUpdate(data.item)">
                        <span class="slider round" :class="data.item.status ? 'active' : ''"></span>
                        </label>
                    </div>                 
                </template>
                <template #cell(value)="data">
                  <div v-if="data.item.type == 3" class="cust_txt" :title="getWeeklyValuesText(data.item.value)">
                    {{ getWeeklyValuesText(data.item.value) }}
                  </div>
                  <div v-else-if="data.item.type == 4" class="cust_txt" :title="getMonthlyValuesText(data.item.value)">
                    {{ getMonthlyValuesText(data.item.value) }}
                  </div>
                  <div v-else-if="data.item.type == 1" class="cust_txt" :title="getDateValue(data.item.value)">
                    {{ getDateValue(data.item.value) }}
                  </div>
                  <div v-else class="cust_txt">
                    Everyday
                  </div>
                </template>
                <template #cell(action)="data">
                  <div class="action-buttons">
                    <button class="action-btn" @click="deleteMaintenance(data.item._id)" title="Delete">
                      <img src="@/assets/icons/delete-icon.svg" alt="Delete" class="action-icon" />
                    </button>
                    <button class="action-btn" @click="editMaintenance(data.item)" title="Edit">
                      <img src="@/assets/icons/edit-icon.svg" alt="Edit" class="action-icon" />
                    </button>
                  </div>
                </template>
                </b-table>
                <!-- Pagination Component -->
                <div class="pagination-wrapper">
                  <pagination-component
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount || totalRows"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
                </div>
              </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-addmaintenance" size="lg" @hidden="closeModal()" title="" class="theme-modal custom-modal" v-model="add_maint_modal" no-close-on-backdrop hide-footer>
      <template #modal-header>
        <div class="custom-modal-header">
          <h5 class="custom-modal-title">{{ edit_maint ? 'Edit Maintenance Window' : 'Create Maintenance Window' }}</h5>
          <button class="custom-modal-close" @click="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <add-maintenance :add_maint_modal="add_maint_modal" @maintmodal="closeModal" :edit_maint="edit_maint" :maint_data="maint_data"></add-maintenance>
    </b-modal>
 </div>
</template>


<script>
import MaintenanceController from "../../../services/maintenanceController";
import AddMaintenance from "./AddMaintenance.vue";
import AddMonitorButton from "../../components/addMonitorButton.vue";
import PaginationComponent from "../../components/PaginationComponent.vue";
import moment from 'moment';
export default {
    name: 'Manitenace',
    components:{AddMaintenance, AddMonitorButton, PaginationComponent},
    data(){
        return{
            maint_data:{},
            add_maint_modal:false,
            edit_maint: false,
            items:[],
            totalRows:0,
            filter:null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 50],
            totalRowsCount: 0,
            tablefields: [
                          { key: "index", label: "Sr", sortable: false },
                          { key: "name", label: "Name", sortable: true },
                          { key: "type", label: "Type", sortable: false },
                          { key: "value", label: "Value", sortable: false },
                          { key: "startTime", label: "Start Time", sortable: false },
                          { key: "duration", label: "Duration", sortable: false },
                          { key: "timezone", label: "Timezone", sortable: false },
                          { key: "status", label: "Status", sortable: false },
                          { key: "action", label: "Action", sortable: false },
                        ],
            loading: false,
            maintenance_opt:[
              { value: null, text:'Please Select' },
              { value: 1, text:'Once' },
              { value: 2, text:'Daily' },
              { value: 3, text:'Weekly' },
              { value: 4, text:'Monthly' },
            ],
            weekly_opt:{1:'Monday',2:'Tuesday',3:'Wednesday',4:'Thursday',5:'Friday',6:'Saturday',0:'Sunday'},
            monthly_opt:{1:'1st',2:'2nd',3:'3rd',4:'4th',5:'5th',6:'6th',7:'7th',8:'8th',9:'9th',10:'10th',11:'11th',12:'12th',13:'13th',14:'14th',15:'15th',16:'16th',17:'17th',18:'18th',19:'19th',20:'20th',21:'21st',22:'22nd',23:'23rd',24:'24th',25:'25th',26:'26th',27:'27th',28:'28th',29:'29th',30:'30th',31:'31st'},
            userinfo:'',
            btn_class:''
        }
    },
    mounted(){
      this.getMantenance()
      let pathName = this.$route.name
      if (pathName === 'Dashboard' || pathName === 'Incidents' || pathName === 'SubUser' || pathName === 'Profile') {
          this.btn_class = 'custom-btn-dark';
      } else {
          this.btn_class = 'add-monitor-btn-green';
      }
    },
    methods:{
        async getMantenance(){
          this.loading = true;
            this.items = []
            let paginationQuery = '?currentPage='+this.currentPage+'&pageSize='+this.perPage
            let response = await MaintenanceController.getAll(paginationQuery)
            console.log('Maintenance API Response:', response); // Debug log
            if (response.result) {
                this.items = response.data;
                this.totalRows = this.items.length;
                // Use the total count from API, or if not available, don't limit to current page items
                this.totalRowsCount = response.totalCount || response.total || response.count || 0;
                
                // If API doesn't return total count and we have a full page, assume there might be more
                if (!this.totalRowsCount && this.items.length === this.perPage) {
                    // Set a high number to enable next button
                    this.totalRowsCount = this.currentPage * this.perPage + 1;
                } else if (!this.totalRowsCount) {
                    // If less than perPage items, this is likely the last page
                    this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.items.length;
                }
            }
            this.loading = false;
        },
        handlePageChange(page) {
          if (page === 'next') {
            this.currentPage++;
          } else if (page === 'prev' && this.currentPage > 1) {
            this.currentPage--;
          }
          this.getMantenance();
        },
        handlePerPageChange(value) {
          this.perPage = value;
          this.currentPage = 1;
          this.getMantenance();
        },
        async deleteMaintenance(id){
          if(confirm("Are you sure want to delete?")){
          this.loading = true;
          let response = await MaintenanceController.deleteMaintenance({"mwid": id});
          if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            this.getMantenance()
          }
          else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
            this.getMantenance()
          }
        }
        },
        editMaintenance(data){
          this.add_maint_modal = false
          this.add_maint_modal = true
          this.maint_data = data;
          this.edit_maint = true;
        },
        closeModal(){
          this.add_maint_modal = false
          this.edit_maint = false;
          this.getMantenance();
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async statusUpdate(data){
        // this.loading = true;
        var s = true
        if(data.status == true){
            s = false
        }
        if (data.status == false) {
          data.status = true;
        } else {
          data.status = false;
        }
        var payload = {"mwid": data._id, "changePayload": {"status":s}}
        let response = await MaintenanceController.editMaintenance(payload)
        if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            // this.getMantenance()
        }
        else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
            this.getMantenance()
          }
      },
      getWeeklyValuesText(values) {
        if (!values || !Array.isArray(values) || values.length === 0) {
          return 'No Value';
        }
        const weekDays = values.map(day => this.weekly_opt[day] || day).filter(Boolean);
        return weekDays.join(', ');
      },
      getMonthlyValuesText(values) {
        if (!values || !Array.isArray(values) || values.length === 0) {
          return 'No Value';
        }
        const monthDays = values.map(day => this.monthly_opt[day] || `${day}th`).filter(Boolean);
        return monthDays.join(', ');
      },
      getDateValue(values) {
        if (!values || !Array.isArray(values) || values.length === 0) {
          return 'No Value';
        }
        // Format dates nicely
        return values.map(date => {
          try {
            return moment(date).format('MMM DD, YYYY');
          } catch (e) {
            return date;
          }
        }).join(', ');
      }
    }
}

</script>

<style scoped>
/* Main wrapper */
.maintenance-page-wrapper {
  padding: 0;
}

/* Header styling */
.maintenance-page-header {
  margin-bottom: 20px;
  margin-top: 30px;
  width: 100%;
}

/* Search input styling */
.maintenance-page-search-wrapper {
  position: relative;
}

.maintenance-page-search-wrapper .input-group {
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  padding: 0px;
}

.maintenance-page-search-wrapper .input-group-text {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px;
}

.maintenance-page-search-wrapper .search-icon {
  color: #344054;
  font-size: 18px;
}

.maintenance-page-search-input {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px 3px 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #111827;
}

.maintenance-page-search-input:focus {
  box-shadow: none;
  background: transparent;
}

.maintenance-page-search-input::placeholder {
  color: #9CA3AF;
}

/* Per page selector styling */
.maintenance-page-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 47px;
}

.maintenance-page-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.maintenance-page-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.maintenance-page-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.maintenance-page-per-page-select:focus {
  box-shadow: none;
  outline: none;
}

.maintenance-page-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

/* Add Maintenance button */
.maintenance-page-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background: #2FB234;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 48px;
}

.maintenance-page-add-btn:hover {
  background: #28A22C;
}

.add-maintenance-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

/* Table container */
.maintenance-page-table-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  overflow: hidden;
  margin: 0 0 20px 0;
  width: 100%;
}

/* Table styling */
.maintenance-page-table {
  margin-bottom: 0;
  width: 100%;
  border: none !important;
  border-radius: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: visible;
}

.maintenance-page-table >>> thead th {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px!important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

/* Center align the Action column header */
.maintenance-page-table >>> thead th:last-child {
  text-align: center !important;
}

.maintenance-page-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #161616;
  vertical-align: middle;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

/* Serial number */
.maintenance-sr-number {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}

/* Status toggle */
.status-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 75%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 24px;
  background-color: #E5E7EB;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #10B981;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Action buttons */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 4px;
  text-decoration: none;
}

.action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}

.action-icon {
  width: 20px;
  height: 20px;
}

/* Pagination wrapper */
.maintenance-page-table-container .pagination-wrapper {
  background: #FFFFFF;
  border-radius: 0 0 20px 20px;
  padding: 0;
  border-top: none !important;
}

/* Remove any top border from pagination component and its children */
.maintenance-page-table-container .pagination-wrapper > *,
.maintenance-page-table-container .pagination-wrapper .custom-pagination {
  border-top: none !important;
  margin-top: 0 !important;
}

/* Loader */
.loader-box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Empty state */
.maintenance-page-table .b-table-empty-row td {
  text-align: center;
  padding: 60px 20px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #6B7280;
}

/* Custom Modal Styles */
.custom-modal >>> .modal-content {
  overflow: visible !important;
}

.custom-modal >>> .modal-dialog {
  overflow: visible !important;
}

.custom-modal >>> .modal {
  overflow: visible !important;
}

.custom-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.custom-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 26px;
  color: #3A3A3A;
  margin: 0;
  text-align: center;
}

.custom-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.custom-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.custom-modal .modal-body {
  padding: 30px;
  font-family: 'Poppins', sans-serif;
  overflow: visible !important;
}

/* Text truncation for value column */
.cust_txt {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .maintenance-page-header > .row > .col-md-4,
  .maintenance-page-header > .row > .col-md-8 {
    margin-bottom: 16px;
  }

  .maintenance-page-header .col-md-8 {
    flex-direction: column;
    align-items: stretch !important;
  }

  .maintenance-page-per-page-wrapper {
    justify-content: center;
    margin-bottom: 12px;
  }

  .maintenance-page-add-btn {
    width: 100%;
    justify-content: center;
  }

  .maintenance-page-table tbody td {
    padding: 16px 20px;
    font-size: 14px;
  }

  .action-buttons {
    justify-content: flex-start;
  }
}
</style>